import React, { useState } from "react";
import { useHover } from "../HoverContext";
import { NodeActions } from "../NodeActions";
import { HoverLabel, moveNodeAction } from "../Renderer";
import { useSelection } from "../SelectionContext";
import { ContainerRenderer } from "./ContainerRenderer";
import { AddContainerZone } from "../Containers/AddContainerZone";

export function SectionRenderer({ section, page, setPage }) {
  const { selectedNodeId, setSelectedNodeId } = useSelection();
  const { hoverNodeId, setHoverNodeId } = useHover();

  const isSelected = selectedNodeId === section.id;
  const isHover = hoverNodeId === section.id;

  const style = {
    
    padding: 12,
    outline: isSelected
      ? "2px solid #1A73E8"
      : isHover
      ? "2px dashed rgba(26,115,232,0.45)"
      : "none",
    outlineOffset: 2,
    position: "relative",
    cursor: "pointer",
    background: "rgba(250,250,250,0.5)"
  };
const sp = section.styles?.custom?.spacing || {};

style.marginTop = sp.marginTop;
style.marginRight = sp.marginRight;
style.marginLeft = sp.marginLeft;

style.paddingTop = sp.paddingTop;
style.paddingRight = sp.paddingRight;
style.paddingLeft = sp.paddingLeft;
  return (
    <section
     draggable
  onDragStart={(e) => {
    e.dataTransfer.setData("nodeId", section.id);
    e.dataTransfer.setData("type", "section");
  }}
  onDragOver={(e) => e.preventDefault()}
  onDrop={(e) => {
    const sourceId = e.dataTransfer.getData("nodeId");
    moveNodeAction(sourceId, section.id,setPage); // We'll implement this smartly
  }}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedNodeId(section.id);
      }}
      onMouseEnter={() => setHoverNodeId(section.id)}
      onMouseLeave={() => {if (selectedNodeId !== section.id) setHoverNodeId(null);}}
    >
      <HoverLabel id={section.id} />

      <NodeActions nodeId={section.id} page={page} setPage={setPage} />

      {section.contents.map((container,index) => (
         <React.Fragment key={container?.id}>
                  { index === container.length - 1 && (<AddContainerZone
                    
              sectionId={section?.id}
              index={index}
               page={page} setPage={setPage}
            />)}
        <ContainerRenderer
          key={container.id}
          container={container}
          page={page}
          setPage={setPage}
          section={section}
        />
        
              <AddContainerZone
                sectionId={section?.id}
               
                index={index + 1}
                 page={page} setPage={setPage}
              />
            
           </React.Fragment>
      ))}
    </section>
  );
}
